/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypeString } from '../models/type-string'

/**
 * Parses values as primitives based upon their passed in types.
 */
export class AttributeParser {
	/**
	 * Parses a value to its primitive.
	 * @param value The value to parse.
	 * @param type The type to parse the value as.
	 */
	static fromAttribute(value: string | null, type: TypeString) {
		switch (type) {
			// Any truthy value works so <some-component prop-name> and <some-component prop-name="true"> both result in propName = true.
			// Of note, <some-component prop-name="false"> and <some-component> both result in propName = false.
			case 'boolean':
				return value !== null && value !== 'false'
			case 'number':
				return value === null ? null : Number(value)
			case 'object':
			case 'array':
				return JSON.parse(value)
		}
		return value
	}

	/**
	 * Parses a primitive to a string.
	 * @param value The value to parse to a string.
	 * @param type The type to parse the value from.
	 */
	static toAttribute(value: any, type: TypeString) {
		switch (type) {
			case 'boolean':
				return value ? '' : false
			case 'object':
			case 'array':
				return JSON.stringify(value)
		}
		return value
	}
}
